import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  Card,
  CardList,
  Carousel,
  ChartEmptyState,
  Databoxes,
  IconList,
  ProgressBar,
} from 'common/components';
import { SelectComponent } from 'common/components/Select';
import { toCommaNumber } from 'common/formatters';
import { uniqBy } from 'common/utils';

/**
 *
 *
 * @export
 * @class DashboardProgressbox
 * @extends {PureComponent}
 * progress bar look chart on dashboard, used for storages and contracts
 * there should NOT be any decimal numbers (but do not round before calculation)
 */
export class DashboardProgressbox extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired, // singular namespace
    label: PropTypes.shape({
      used: PropTypes.string,
      free: PropTypes.string,
    }),
    source: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string,
        value: PropTypes.number,
        max: PropTypes.number,
        type: PropTypes.string,
      })
    ),
    addURL: PropTypes.string,
    navigateTo: PropTypes.func.isRequired,
    showVariety: PropTypes.bool,
  };

  static defaultProps = {
    label: {},
    source: [],
    addURL: '',
    showVariety: true,
  };

  state = {
    filteredSource: null,
  };

  _getTotal = name => {
    const { filteredSource } = this.state;
    let total = 0;
    if (filteredSource) {
      total = filteredSource.reduce((sum, current) => sum + current[name], 0);
    }
    // round just in case
    return Math.round(total);
  };

  _getContent = card => {
    const { label, showVariety } = this.props;
    const { crop } = card;

    return (
      <Fragment>
        {crop && (
          <IconList
            list={[
              {
                label: `${crop.name} ${
                  showVariety && crop.variety ? crop.variety : ''
                }`,
                icon: 'crop',
              },
            ]}
          />
        )}
        <ProgressBar
          barSize="is-small"
          {...card}
          unit={card.type && card.type.slice(0, 2)}
          label={{
            used: label ? label.used : '',
            free: label ? label.free : '',
          }}
        />
      </Fragment>
    );
  };

  _getCardData = card => ({
    title: card.title,
    content: this._getContent(card),
    link: card.url,
  });

  // TODO: not sure about the requirement, please adjust as needed
  _onFilterChange = value => {
    const { source } = this.props;
    // if value is empty, show all
    if (!value) {
      this.setState({ filteredSource: source });
      return null;
    }

    const { name } = JSON.parse(value);
    const filteredSource = []
      .concat(source)
      .filter(data => data.crop && data.crop.name === name);
    this.setState({ filteredSource });
  };

  _renderDropdown = () => {
    const { source, title } = this.props;
    let options = uniqBy(
      []
        .concat(source)
        .filter(data => data.crop)
        .map(data => {
          return {
            label: data.crop ? `${data.crop.name}` : '',
            value: JSON.stringify(data.crop),
          };
        }),
      'label'
    );

    // sort by crop name?
    if (options.length > 1) {
      options.sort((a, b) =>
        a.label < b.label ? -1 : a.label > b.label ? 1 : 0
      );
    }
    // prepend `All` options on top
    options = [{ label: `All ${title}`, value: '' }].concat(options);

    return (
      <SelectComponent
        name="crop"
        options={options}
        input={{
          onChange: e => {
            this._onFilterChange(e.target.value);
          },
        }}
        meta={{ touched: false }}
        theme={['stretch']}
        disablePromptOption
      />
    );
  };

  _renderCardList = filteredSource => {
    let groups = [];
    let counter = 0;
    // TODO: better way to group by 3 items
    filteredSource.forEach((source, idx) => {
      counter = Math.ceil((idx + 1) / 3) - 1;
      if (!groups[counter]) {
        groups[counter] = [];
      }
      groups[counter].push({
        ...source,
        // round value just in case
        value: Math.round(source.value),
        max: Math.round(source.max),
      });
    });

    return groups.map((group, idx) => (
      <CardList
        key={`carousel-${group[0].id}${idx}`}
        cards={group.map(this._getCardData)}
        message="No data found"
      />
    ));
  };

  componentDidMount() {
    const { source } = this.props;
    this.setState({ filteredSource: source });
  }

  render() {
    const { title, label, addURL, navigateTo } = this.props;
    const { filteredSource } = this.state;
    const total = this._getTotal('value');
    const free = this._getTotal('max') - total;
    const unit =
      filteredSource && filteredSource[0] && filteredSource[0].type.slice(0, 2);

    if (!filteredSource || !filteredSource.length) {
      return (
        <ChartEmptyState
          chartTitle={`${title}s Summary`}
          navigateTo={() => navigateTo(addURL)}
          title={`You have not added any ${title.toLowerCase()}s`}
          subTitle={`Start by adding a new ${title.toLowerCase()}`}
          buttonText={`Add ${title}`}
        />
      );
    } else {
      return (
        <Card
          header={
            title && <h2 className="text--header text--medium">{title}</h2>
          }
          headerright={this._renderDropdown()}
          theme={['noborder']}
        >
          {total + free > 0 && (
            <Databoxes
              data={[
                {
                  label: label.used,
                  line: { output: toCommaNumber(total), unit },
                },
                {
                  label: label.free,
                  line: { output: toCommaNumber(free), unit },
                },
              ]}
            />
          )}
          <div className="columns__row">
            {filteredSource && (
              <Carousel>{this._renderCardList(filteredSource)}</Carousel>
            )}
          </div>
        </Card>
      );
    }
  }
}

const mapDispatch = {
  navigateTo: push,
};

export default connect(
  null,
  mapDispatch
)(DashboardProgressbox);



// WEBPACK FOOTER //
// ./src/containers/DashboardProgressbox/index.js